'use client';
import React from 'react';

interface SuccessAnimationProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  subMessage?: string;
  className?: string;
}

const SIZE_MAP = {
  sm: { icon: 'success-icon-sm', svg: 10, stroke: 2.5 },
  md: { icon: 'success-icon-md', svg: 16, stroke: 2.5 },
  lg: { icon: 'success-icon-lg', svg: 22, stroke: 2.5 },
};

export default function SuccessAnimation({
  size = 'md',
  message,
  subMessage,
  className = '',
}: SuccessAnimationProps) {
  const s = SIZE_MAP[size];
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`success-icon ${s.icon}`}>
        <svg
          width={s.svg}
          height={s.svg}
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth={s.stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      {(message || subMessage) && (
        <div className="animate-fade-in-up">
          {message && (
            <p className="font-semibold text-green-800 text-sm leading-tight">{message}</p>
          )}
          {subMessage && (
            <p className="text-green-600 text-xs mt-0.5">{subMessage}</p>
          )}
        </div>
      )}
    </div>
  );
}
